import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
  /**
   * This class connect cloud function (optional)
   */
export class CloudfunctionsService {



  url='http://localhost:5000/transportapp-1529717660459/us-central1';

  constructor(private http: HttpClient) {

  }

  /**
   * Get all users
   */

  getAllUsers(){
     return this.http.get(`${this.url}/getUsers`);
  }
}
